import { Badge, Group } from "@mantine/core";
import StatsField from "./reusable/StatsField";
import { IconFlame } from "@tabler/icons";
import ContractStateToggle from "./ContractStateToggle";

const BurningEnabledToggle = ({ contractId, contractInfo, onUpdate }) => {
  return (
    <Group position="apart" grow>
      <StatsField
        label="Burning Enabled"
        value={
          <Badge
            size="xs"
            color={contractInfo.burningEnabled ? "green" : "red"}
          >
            {contractInfo.burningEnabled.toString()}
          </Badge>
        }
        icon={IconFlame}
      />
      <ContractStateToggle
        contractId={contractId}
        abi={[
          {
            inputs: [],
            name: "toggleBurning",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function"
          }
        ]}
        functionName="toggleBurning"
        enabled={contractInfo.burningEnabled}
        onCompleted={() => onUpdate(contractId)}
        label="Toggle burning"
      />
    </Group>
  );
};

export default BurningEnabledToggle;
